import axios from 'axios'
import endpoints from '../../endpoints'
import {
  SetPrimaryGuardianPayload,
  StudentGuardianLinkAPIPayload,
  StudentLinkedGuardian,
} from './type'
import {APIResponse} from '../../../types/type'

const API_URL = process.env.REACT_APP_API_URL

export async function fetchStudentList({
  studentClass,
  division,
  school,
  shift
}: {
  studentClass: string
  division: string
  school?: string | number
  shift?: string | number
}) {
  try {
    const response = await axios.put(API_URL + endpoints.student.list, {
      class: studentClass,
      division: division,
      sub_school_id:school ? String(school) : '',
      shift_id:shift ? String(shift) : '',
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export async function getStudentById(id: string) {
  try {
    const response = await axios.get(API_URL + endpoints.student.getById + id)
    return response.data
  } catch (error) {
    throw error
  }
}

export async function createStudent(body: any) {
  try {
    const response = await axios.post(API_URL + endpoints.student.create, body)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function updateStudent(body: any) {
  try {
    const response = await axios.post(API_URL + endpoints.student.update, body)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function deleteStudent(studentId: string) {
  try {
    const response = await axios.delete(API_URL + endpoints.student.delete + studentId)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function fetchStudentTripDetails(studentId: string) {
  try {
    const response = await axios.get(API_URL + endpoints.student.studentTrip + studentId)
    return response.data
  } catch (error) {
    throw error
  }
}

export async function studentTripMutate(payload: any) {
  try {
    const response = await axios.post(API_URL + endpoints.student.studentTripMutate, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export async function fetchStudentGuardianDetails(
  studentId: string | number
): Promise<APIResponse<StudentLinkedGuardian[]>> {
  try {
    const response = await axios.get<APIResponse<StudentLinkedGuardian[]>>(
      `${API_URL}${endpoints.student.studentGuardian}${studentId}`
    )
    return response.data
  } catch (error) {
    throw error
  }
}

export async function linkGuardianToStudent(body: StudentGuardianLinkAPIPayload) {
  try {
    const response = await axios.post(API_URL + endpoints.guardian.linkToStudent, body)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function addNFCtoStudent(payload: any) {
  try {
    const response = await axios.put(API_URL + endpoints.nfc.createUserNFC, payload)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function getStudentNFC(studentId: string | number) {
  try {
    const response = await axios.put(API_URL + endpoints.nfc.getUserNFC, {
      id: studentId,
      type: 'student',
    })
    return response.data
  } catch (error) {
    throw error
  }
}
export async function setPrimaryGuardian(payload: SetPrimaryGuardianPayload) {
  try {
    const response = await axios.post(API_URL + endpoints.guardian.setPrimary, payload)
    return response.data
  } catch (error) {
    throw error
  }
}
// ✅ GET CONFIG (to check sync_data)
export async function fetchAppConfig(): Promise<APIResponse<any>> {
  const response = await axios.get(API_URL + endpoints.sync.config)
  return response.data
}

// ✅ TRIGGER SYNC
export async function triggerSync(payload: any) {
  try {
    const response = await axios.get(API_URL + endpoints.sync.trigger, payload)
    return response.data
  } catch (error) {
    throw error
  }
}